import * as React from "react";

const flags = {
  ...localStorage,
};

export function SpsFlagsRow({ initialKey, initialValue }) {
  const [storedValue, setStoredValue] = useLocalStorage(initialKey, initialValue);
  const [enteredValue, setEnteredValue] = React.useState("");
  const [editing, setEditing] = React.useState(false);
  return (
    <tr>
      <td>{initialKey}</td>
      <td>
        {editing ? (
            <>
          <input
            type="text"
            value={enteredValue}
            onChange={(e) => setEnteredValue(e.target.value)}
          ></input>
          <button
              onClick={() => {
                setStoredValue(enteredValue);
                setEnteredValue('');
                setEditing(false);
              }}
            >
              save
            </button>
          </>
        ) : (
          <>
            {storedValue}{" "}
            <button
              onClick={() => {
                setEnteredValue(storedValue);
                setEditing(true);
              }}
            >
              edit
            </button>
          </>
        )}
      </td>
    </tr>
  );
}

export function SpsFlags(props) {
  const { closeSpsFlags } = props;
  const [showFlags, setShowFlags] = React.useState(true);
  return showFlags ? (
    <div className="sps-flags-container">
      <h1>Set Commerce Platform flags</h1>
      <table>
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(flags).map(([key, value]) => {
            return (
              <SpsFlagsRow key={key} initialKey={key} initialValue={value} />
            );
          })}
        </tbody>
      </table>
      <br />
      <button
        onClick={() => {
          setShowFlags(false);
          closeSpsFlags();
        }}
      >
        Continue to Load Commerce Platform
      </button>
    </div>
  ) : (
    <></>
  );
}

// Hook from
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = React.useState(() => {
      try {
        // Get from local storage by key
        const item = window.localStorage.getItem(key);
        // Parse stored json or if none return initialValue
        return item ? item : initialValue;
      } catch (error) {
        // If error also return initialValue
        console.log(error);
        return initialValue;
      }
    });
  
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = value => {
      try {
        // Allow value to be a function so we have same API as useState
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        window.localStorage.setItem(key, valueToStore);
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.log(error);
      }
    };
  
    return [storedValue, setValue];
  }